import { RoleEnum } from '@acme/api';
import { Image } from '@acme/assets';
import { useModal } from '@acme/foundation';
import { Button } from 'flowbite-react';

interface RoleSelectionProps {
  onSelectRole: (role: RoleEnum) => void;
}

export const RoleSelection = ({ onSelectRole }: RoleSelectionProps) => {
  const { openConfirmModal } = useModal();

  const getRoleTitle = (role: RoleEnum) => {
    switch (role) {
      case RoleEnum.Client:
        return 'Организация типа: Клиент';
      case RoleEnum.Provider:
        return 'Организация типа: Поставщик ликвидности';
      default:
        return 'Выбор роли';
    }
  };

  const getRoleDescription = (role: RoleEnum) => {
    switch (role) {
      case RoleEnum.Client:
        return 'Вы сможете с помощью нашей платформы качественно осуществлять исполнение международных договоров';
      case RoleEnum.Provider:
        return 'Вы сможете с помощью нашей платформы выгодно продавать и покупать фиатную валюту';
      default:
        return '';
    }
  };

  const handleRoleClick = async (role: RoleEnum) => {
    const confirmed = await openConfirmModal({
      title: getRoleTitle(role),
      content: getRoleDescription(role),
      okBtn: 'Подтвердить',
      cancelBtn: 'Отмена',
      opaqueBackground: true,
    });

    if (confirmed) {
      onSelectRole(role);
    }
  };

  return (
    <div className="flex flex-col gap-6 w-full items-center">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 w-full">
        <div className="flex flex-col items-center gap-2 p-6 bg-gray-50 rounded-lg">
          <div className="w-48 h-48 flex items-center justify-center">
            <Image
              name="fly"
              width="100%"
              height="100%"
              alt="Клиент"
              className="object-contain"
            />
          </div>
          <Button
            color="primary"
            className="w-full"
            onClick={() => handleRoleClick(RoleEnum.Client)}
          >
            Клиент
          </Button>
        </div>

        <div className="flex flex-col items-center gap-2 p-6 bg-gray-50 rounded-lg">
          <div className="w-48 h-48 flex items-center justify-center">
            <Image
              name="money"
              width="100%"
              height="100%"
              alt="Поставщик ликвидности"
              className="object-contain"
            />
          </div>
          <Button
            color="primary"
            className="w-full"
            onClick={() => handleRoleClick(RoleEnum.Provider)}
          >
            Поставщик ликвидности
          </Button>
        </div>
      </div>
    </div>
  );
};
